import { useEffect } from 'react';
import { Button } from "@mui/material";
import { useDispatch } from 'react-redux';
import { toast } from "react-toastify";
import _ from "lodash";
import { useSelector } from 'react-redux';
import IconLeftArrow from "src/assets/images/icon_left_arrow.svg";
import { DeactiveAccount, editDepot, getByIdDepot } from 'src/thunks/depotUsers';
import IconRemove from "src/assets/images/icon_remove.svg";
import toastMessages from "src/constant/toastMessages.json";
import { GetError } from "src/constant";
import { getAllNofificationForDashboard } from "src/thunks/dashboard";


export const DeactiveAccountForm = ({ handleBackButtonClick, isDeactivateDepotInfo, handleDeactivateAccountModalClose, getAllDepotPerson, selectedData, isFullDetail, setIsFullDetails }) => {

      /** redux store useDispatch & useSelector ------------------------------ **/
      const dispatch = useDispatch();
      const { individualDepotInfo } = useSelector((state) => state.depotUsers);

      /** hooks useState ----------------------------------------------------- **/


      /** hooks useEffect----------------------------------------------------- **/
      useEffect(() => {
            getByIdDepotInfo()
      }, [])

      /** handler functions--------------------------------------------------- **/

      /** Function to retrieve information about a depot by its ID ----------------- **/
      const getByIdDepotInfo = async () => {
            try {
                  let res = await dispatch(getByIdDepot(isDeactivateDepotInfo?.id))
            } catch (err) {
                  toast.error(GetError(err?.response?.data?.errors) || "something issue");
            }
      }

      /** Function executes when clicking on 'Deactivate Account' ------------------- **/
      const handleDeactiveAccountClick = async () => {
            try {
                  if (isFullDetail) {
                        let result = await dispatch(DeactiveAccount({ ...selectedData })).unwrap();
                        if (result) {
                              setIsFullDetails(false)
                              handleDeactivateAccountModalClose(false);
                              toast.success(toastMessages.userDeactivated)
                              getAllDepotPerson();
                              handleBackButtonClick();
                        }
                  } else {
                        const oldDepotUsers = _.filter(individualDepotInfo?.depotUsers, (d1) => d1.userId !== selectedData?.id)
                        const usersArray = oldDepotUsers?.map((item, index) => {
                              return { userId: item.userId };
                        });

                        let model = {
                              "id": individualDepotInfo?.id || 0,
                              "name": individualDepotInfo?.name || "",
                              "code": individualDepotInfo?.code || "",
                              "address": {
                                    "street1": individualDepotInfo?.address?.street1 || "",
                                    "country": individualDepotInfo?.address?.country || "",
                                    "city": individualDepotInfo?.address?.city || "",
                                    "zip": individualDepotInfo?.address?.zip || "",
                              },
                              "internalArea": individualDepotInfo?.internalArea || 0,
                              "externalArea": individualDepotInfo?.externalArea || 0,
                              "depotUsers": usersArray ? usersArray : [],
                              removeAllocationActivity: true,
                              NewDeallocationUsers: selectedData
                        }
                        let result = await dispatch(editDepot({ data: model })).unwrap();
                        if (result) {
                              handleDeactivateAccountModalClose(false);
                              toast.success(toastMessages.userDeactivated)
                              getAllDepotPerson();
                        }
                  }
                  setTimeout(() => {
                        dispatch(getAllNofificationForDashboard(1, 20));
                  }, 2000);
            } catch (err) {
                  toast.error(GetError(err?.response?.data?.errors) || "something issue");
            }

      }
      return <>
            < div >
                  <div className="depot-form-header-style">
                        {isFullDetail ? <span className="allocate-mgnr-header-color me-2">DEACTIVATE</span>
                              : <span className="allocate-mgnr-header-color me-2">REMOVE ALLOCATION</span>}
                        <span className="allocate-mgnr-subheader-color">{selectedData?.firstName || ""} {selectedData?.lastName || ""}</span>
                  </div>
                  <div style={{ paddingLeft: 100, paddingRight: 100 }} >
                        <div className="d-flex flex-column" style={{ marginTop: 100 }}>
                              <span className="depotManagerName-style common-text-for-removeDepotManager">{selectedData?.firstName || ""} {selectedData?.lastName || ""}</span>
                              {isFullDetail ? <span className="removeDepotManager-text-removed common-text-for-removeDepotManager mb-3">account will be de-activated</span>
                                    : <span className="removeDepotManager-text-removed common-text-for-removeDepotManager mb-3">account will be removed from {isDeactivateDepotInfo?.name}</span>}
                              <span className="long-text-style-unlist-depot mb-2">This does not delete any data.</span>
                              {isFullDetail && <>
                                    <span className="long-text-style-unlist-depot mb-2">This account will not able to login until re-activated.</span>
                                    <span className="long-text-style-unlist-depot">The account can be re-activated simply by allocating to a depot.</span>
                              </>}
                        </div>

                        <div className="d-flex flex-column" style={{ marginTop: 100 }}>
                              <span className="mb-3 confirm-msg-for-removeDepotManager">Are you sure you want to proceed?</span>
                              <div className="d-flex flex-row">
                                    <Button variant="outlined" className="btn-bootstrap-submit-style" startIcon={<img src={IconLeftArrow} width={15} height={15} alt="new"></img>} onClick={handleDeactivateAccountModalClose} type="submit"
                                    >
                                          No, Go Back
                                    </Button>
                                    <Button variant="outlined" className="btn-bootstrap-submit-style ms-3" style={{ color: "red", borderColor: "red" }} onClick={() => handleDeactiveAccountClick()} startIcon={<img src={IconRemove} width={15} height={15} alt="new"></img>}
                                    >
                                          {isFullDetail ? "Yes, De-activate account" : "Yes, Remove Allocation"}
                                    </Button>

                              </div>
                        </div>

                  </div>
            </div >
      </>;
};